import { useEffect, useState } from "react";

const STORAGE_KEY = "universe-pos-theme";

export const POS_THEMES = [
  { id: "classic", label: "Universe Classic", description: "Original POS", colors: ["#3a84f8", "#26bf89", "#ffffff"] },
  { id: "emerald", label: "Emerald Night", description: "Charcoal and green", colors: ["#121b1f", "#263943", "#32d77c"] },
  { id: "crimson", label: "Crimson Flow", description: "Warm white and red", colors: ["#fffaf6", "#ed282f", "#f4e9e6"] },
  { id: "evergreen", label: "Evergreen Studio", description: "Soft white and deep green", colors: ["#f7f8f6", "#06563c", "#82cba6"] },
  { id: "violet", label: "Violet Pulse", description: "Violet and near black", colors: ["#0a0a0a", "#8e60ff", "#ffffff"] },
];

export function usePOSTheme() {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return POS_THEMES.some((option) => option.id === stored) ? stored : "classic";
    } catch {
      return "classic";
    }
  });

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, theme); } catch { /* private browsing */ }
    // React portals used by payment dialogs sit outside the terminal element.
    document.body.dataset.posTheme = theme;
    return () => { delete document.body.dataset.posTheme; };
  }, [theme]);

  return [theme, setTheme];
}

export default function POSThemeSwitcher({ theme, onChange }) {
  return (
    <div className="pos-theme-control" role="group" aria-label="POS appearance">
        <div className="pos-theme-heading"><div><strong>Appearance</strong><small>Choose a workspace style</small></div></div>
          <div className="pos-theme-options">{POS_THEMES.map((option) => (
            <button type="button" key={option.id} className={`pos-theme-option ${theme === option.id ? "is-selected" : ""}`} onClick={() => onChange(option.id)} aria-pressed={theme === option.id}>
              <span className="pos-theme-swatches">{option.colors.map((color) => <i key={color} style={{ backgroundColor: color }} />)}</span>
              <span className="pos-theme-option-text"><strong>{option.label}</strong><small>{option.description}</small></span>
              <span className="pos-theme-indicator" aria-hidden="true" />
            </button>
          ))}</div>
    </div>
  );
}
